import { IWheelProps } from '~/actions/extraHTML/wheelOfFortune/index';
import { randomIntFromInterval } from '~/utils/randomIntFromInterval';

export const getWinArrowStyles = (
  wheelSize: number
) => {
  const arrowSize = wheelSize / 15;

  return `
    width: ${arrowSize}px;
    height: ${arrowSize}px;
    border-radius: 0 0 3px 0;
    background: #fff;
    left: ${wheelSize / 2 - arrowSize / 2}px;
    transform: rotate(45deg);
    top: -${arrowSize / 3}px;
    box-shadow: 6px 3px 9px rgba(12, 21, 45, .14);
  `;
};

export const getDegree = (sectorLength: number) => 360 / sectorLength;

interface IGetRotatedElementsStyles {
  diameter: number;
  wheelParams: IWheelProps;
  isMobile?: boolean;
}

export const getRotatedElementsStyles = ({
  diameter,
  wheelParams,
  isMobile,
}: IGetRotatedElementsStyles) => {

  const mobileDegrees = isMobile ? 1990 : 0;

  const degree = 360 / wheelParams.sectors.length;
  const winSectorNumber = wheelParams.animationProps.winSectorNumber;

  const randomSpinNumber = randomIntFromInterval(3, 5);

  const rotationEnd =
    360 * randomSpinNumber - degree * (winSectorNumber - 1) + degree / 2 + 90 + mobileDegrees;

  const animationDuration = randomSpinNumber <= 4 ? 2 : 3;

  const randomStartValue = degree + mobileDegrees; /* * randomIntFromInterval(1, maxSectorNumber) */;

  return `
    width: ${diameter}px;
    height: ${diameter}px;
    animation-duration: ${animationDuration}s;
    transform: rotate(${randomStartValue}deg);
    --min-rotate-value: ${randomStartValue}deg;
    --max-rotate-value: ${rotationEnd}deg;
 `;
};

export const getWheelBorderStyles = (diameter: number) => `
  // filter: blur(${diameter / 100}px);
  width: ${diameter + 18}px;
  height: ${diameter + 18}px;
  top: -${diameter  - 9}px;
  left: -${diameter - 9}px;
  border: 9px rgba(0, 0, 0, .25) solid;
`;
